export function getMyTasksCount({ tasks = [], scopingTasks = [], auditTasks = [], currentUserId }) {
  if (!currentUserId) return 0;

  const map = new Map();

  [...tasks, ...scopingTasks, ...auditTasks].forEach((task) => {
    if (!task) return;
    if (task.assigneeId !== currentUserId) return;
    if (task.done === true) return;

    const id = task.id ?? task.taskId;
    if (!id) return;

    map.set(id, task);
  });

  return map.size;
}

export function normalizeProjectTasksForCount(tasks = []) {
  return tasks.map((task) => ({
    id: task.id ?? task.taskId,
    assigneeId: task.assigneeId ?? null,
    done: task.done === true || task.status === "Done" || task.status === "Cancelled",
  }));
}

export function flattenScopingTasksForCount(scoping = []) {
  const out = [];

  scoping.forEach((card) => {
    (card?.tasks || []).forEach((task) => {
      out.push({
        id: task.id,
        assigneeId: task.assigneeId ?? null,
        done: task.done === true,
      });

      (task?.subtasks || []).forEach((subtask) => {
        out.push({
          id: subtask.id,
          assigneeId: subtask.assigneeId ?? null,
          done: subtask.done === true,
        });
      });
    });
  });

  return out;
}

export function flattenAuditTasksForCount(audits = []) {
  const out = [];

  audits.forEach((audit) => {
    (audit?.auditTasks || []).forEach((task) => {
      out.push({
        id: task.id,
        assigneeId: task.assigneeId ?? null,
        done: task.status === "Done" || task.done === true,
      });
    });
  });

  return out;
}
